module.exports = __webpack_public_path__ + "img/co2.07f3c7f1.png";